import { InjectionToken } from '@angular/core';

export const REST_API_URL = new InjectionToken<string>('REST_API_URL');

export type RolesPermissionsTranslateFn = (
  textId: string,
  fallback?: string,
) => string;

export const ROLES_PERMISSIONS_TRANSLATE =
  new InjectionToken<RolesPermissionsTranslateFn>(
    'ROLES_PERMISSIONS_TRANSLATE',
  );
